import { useReducer } from 'react'
import useHistoryUrlFilters from '@/hooks/orderHistory/useHistoryUrlFilters'
import ordersReducer, { ordersDefault } from './orders'
import filtersReducer, { filtersDefault } from './filters'

export default function () {
  const initialFilters = useHistoryUrlFilters(filtersDefault)

  const [ordersStore, ordersDispatch] = useReducer(ordersReducer, ordersDefault)
  const [filtersStore, filtersDispatch] = useReducer(
    filtersReducer,
    initialFilters
  )

  return {
    store: { ordersStore, filtersStore },
    reducers: { ordersDispatch, filtersDispatch },
  }
}
